// Generic Timer records (MONETIZATION.md §5): any long action that tokens can rush.
// { id, kind, ref: { type, id }, refId, startDay, totalDays, daysLeft, work: null, rushK, rushable, tokensSpent, data }
import { nextId } from './util.js';
import { onDrillTimerDone } from './drilling.js';
import { onSurveyDone } from './survey.js';
import { onShippingDone } from './production.js';
import { onResearchTimerDone } from './research.js';

// Rush constant K per kind (MONETIZATION §3); kinds not listed are not rushable.
export const RUSH_K = {
  RIG_UP: 0.8, CASING: 1.0, COMPLETION: 1.0, CAPPING: 1.0, FISHING: 1.0, CLEANOUT: 1.0, GAS_BLOW: 1.0,
  TRIP: 1.0, DRESS: 1.0, STRAIGHTEN: 1.0, SURVEY: 1.0, SHIPMENT: 0.6, RESEARCH: 2.0, REPAIR: 1.0, SHUT_IN: 1.0,
  // M2 rotary era
  KILL: 1.0, CEMENTING: 1.0, RECOMPLETE: 1.0, CONTRACT_MOB: 0.6, SKID: 0.8,
};
export const TIMER_KINDS = Object.keys(RUSH_K);

const REF_TYPE = { SURVEY: 'field', SHIPMENT: 'field', RESEARCH: 'research' };

export function startTimer(state, kind, refId, days, data = {}) {
  const id = nextId(state, 't');
  const d = Math.max(1, Math.ceil(days - 1e-9));
  state.timers[id] = {
    id, kind, ref: { type: REF_TYPE[kind] ?? 'well', id: refId }, refId,
    startDay: state.day, totalDays: d, daysLeft: d, work: null,
    rushK: RUSH_K[kind] ?? 1, rushable: kind in RUSH_K, tokensSpent: 0, data,
  };
  return state.timers[id];
}

export function cancelTimer(state, id) {
  if (id) delete state.timers[id];
}

export function timersFor(state, refId) {
  return Object.values(state.timers).filter((t) => t.refId === refId);
}

const idNum = (t) => Number(String(t.id).slice(1)) || 0;

// Called once per tick. Timers are processed in creation order for determinism.
// RESEARCH timers are driven by research.js (progress depends on funding), so they are skipped here.
export function tickTimers(state) {
  const list = Object.values(state.timers).sort((a, b) => idNum(a) - idNum(b));
  for (const t of list) {
    if (!state.timers[t.id] || t.kind === 'RESEARCH') continue;
    t.daysLeft -= 1;
    if (t.daysLeft <= 0) finishTimer(state, t, false);
  }
}

export function finishTimer(state, t, rushed = false) {
  delete state.timers[t.id];
  switch (t.kind) {
    case 'SURVEY': return onSurveyDone(state, t, rushed);
    case 'SHIPMENT': return onShippingDone(state, t, rushed);
    case 'RESEARCH': return onResearchTimerDone(state, t, rushed);
    default: return onDrillTimerDone(state, t, rushed);
  }
}
